import React from 'react'
import ClassNames from 'classnames'

import Pagination from 'react-js-pagination'
//https://www.npmjs.com/package/react-js-pagination

import { PaginationStyle } from './styled'

import { Image } from '../../components'
import { ICONS } from '../../themes'

export class Paginate extends React.PureComponent {
  render() {
    const { className, totalItemsCount } = this.props
    return (
      <PaginationStyle className={ClassNames('pagination-wrapper', className)}>
        <Pagination
          innerClass="paginations"
          itemClass="pagination"
          itemClassNext="nav"
          itemClassPrev="nav"
          linkClass="link"
          firstPageText={
            <Image
              className="first-page icon"
              src={ICONS['icon-double-chevon-left.svg']}
              alt="first page"
            />
          }
          prevPageText={
            <Image
              className="prev icon"
              src={ICONS['icon-chevon-left.svg']}
              alt="prev"
            />
          }
          nextPageText={
            <Image
              className="next icon"
              src={ICONS['icon-chevon-right.svg']}
              alt="next"
            />
          }
          lastPageText={
            <Image
              className="last-page icon"
              src={ICONS['icon-double-chevon-right.svg']}
              alt="last page"
            />
          }
          countPerPage={5}
          itemsCountPerPage={10}
          pageRangeDisplayed={5}
          activePage={1}
          totalItemsCount={totalItemsCount}
          onChange={() => ({})}
          {...this.props}
        />
      </PaginationStyle>
    )
  }
}
Paginate.defaultProps = {
  totalItemsCount: 0,
}
